import { SetStateAction, useCallback, useEffect, useRef, useState } from "react";
import siteLogo from "../../assets/images/site-logo-small.avif";
import NavItem from "./nav-item";
import LoginHeaderDropdown from "./login-header-dropdown";
import HeaderAlert from "../header-alert/header-alert";
import SearchIcon from "../../assets/svg/search-icon";
import P2MobileNavItem from "./P2MobileNavItem";
import HamburgerIcon from "../../assets/svg/hamburger";
import header_footer_json from "../../utils/shared/header-footer-nav-items.json";
import { CrossIcon } from "../../assets/svg";
import SearchIconHeader from "../../assets/svg/search-icon-header";
import CrossHeaderIcon from "../../assets/svg/cross-header";
import siteLogoSvg from "../../assets/images/site-logo-small-svg.svg";

interface OldHeaderProps{
  isAuth:boolean;
  onClick:any;
}

function OldHeader({...props}:OldHeaderProps) {

  const navItem = header_footer_json["navigation-items"];
  const infoItems = header_footer_json["info-items"]

  const [showHeaderAlert, setShowHeaderAlert] = useState<boolean>(false);
  const [isMobileNavOpened, setIsMobileNavOpened] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const mobileNavDiv = useRef<HTMLDivElement|null>(null);
  const [showSiteSearch, setShowSiteSearch] = useState<boolean>(false);

  const [message, setMessage] = useState('');

  const handleChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setMessage(event.target.value);
  };

  useEffect(() => {
    const callback = () => setNavHeight(mobileNavDiv.current?.scrollHeight?mobileNavDiv.current?.scrollHeight:0);
    callback();
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, []);

  useEffect(() => {
    const callback = () => {
      //according to old-header.scss, using 64.063em which === 1025px
      if(window.innerWidth < 1025 && showSiteSearch === true){
        setShowSiteSearch(false);
      }
    }
    callback();
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, [showSiteSearch])


  const onHamburgerPress = useCallback(()=>{
    setIsMobileNavOpened(state => !state);
    setShowHeaderAlert(false)
  },[])
  
  const onWarningAlertPress = useCallback(()=>{
    setShowHeaderAlert((prev) => !prev)
  },[])


  const resetParentHeight = useCallback((diff: number)=>{
     setNavHeight(height => height + diff)
  },[])
  return (
    <header style={{ justifyContent: "center", position: "relative" }} className="old-header-header">
      <div className="old-header-top">
        <div className="old-header-margin" />
        <div className="old-header-top-container">
          <div className="old-header-site-logo">
            <a href="https://www.hdb.gov.sg/cs/infoweb/homepage" aria-label="hdb-home">
              {/* <img
                  width={200}
                  height={49}
                  src={siteLogo}
                  alt="Housing & Development Board"
                /> */}
              <picture>
                <source width={200} height={49} srcSet={siteLogo} type="image/avif" />
                <img width={200} height={49} src={siteLogoSvg} alt="Housing & Development Board" className="polymer-site-logo" />
              </picture>
            </a>
          </div>
          <ul className="old-header-primary-nav">
            {navItem.map((item, _index: number) => {
              const key = `header_${_index}_${item.title}`;
              return <NavItem key={key} title={item.title} description={item.description} link={item.link} sub_nav={item.sub_nav} />;
            })}
          </ul>
          <div className="old-header-login-container">
            <LoginHeaderDropdown isAuth={props.isAuth} onClick={props.onClick} />
            <div className="old-header-login-container-search" onClick={() => setShowSiteSearch((prev) => !prev)}>
              {showSiteSearch ? <CrossHeaderIcon /> : <SearchIconHeader />}
            </div>
          </div>

          {!isMobileNavOpened ? (
            <div className="polymer-header-item display-md-block" onClick={onHamburgerPress}>
              <HamburgerIcon />
            </div>
          ) : (
            <div className="polymer-header-item-cross" onClick={onHamburgerPress}>
              <CrossIcon />
            </div>
          )}
        </div>
      </div>
      <div className="polymer-header-mobile-nav-wrapper">
        <div
          className="polymer-header-mobile-nav-container"
          style={{
            height: isMobileNavOpened ? navHeight : 0,
            borderWidth: isMobileNavOpened ? "1px" : "0px",
          }}
          ref={mobileNavDiv}
        >
          <div className="polymer-header-mobile-nav">
            <div className="site-search-mobile">
              <div className="wrapper-margin">
                <input type="text" className="search-bar-mobile no-outline" placeholder="Search our website" onChange={handleChange} value={message} />
                <a type="submit" className="site-search-btn" aria-label="search-btn" href={`https://www.hdb.gov.sg/cs/infoweb/search-result?q=${message}`}>
                  <SearchIcon />
                </a>
              </div>
            </div>
            <div className="polymer-header-mobile-nav-separator" />
            {infoItems.map((item, itemIndex) => {
              const key = `mobile_nav_item_${itemIndex}_${item.name}`;
              return <P2MobileNavItem key={`${key}`} item={item} resetParentHeight={resetParentHeight} />;
            })}
          </div>
        </div>
      </div>
      <div className="site-search" style={{ display: showSiteSearch ? "flex" : "none" }}>
        <div className="wrapper-margin">
          <input type="text" className="search-bar no-outline" placeholder="Search our website" onChange={handleChange} value={message} />
          <a type="submit" className="site-search-btn" aria-label="search-btn" href={`https://www.hdb.gov.sg/cs/infoweb/search-result?q=${message}`}>
            <SearchIcon />
          </a>
        </div>
      </div>
    </header>
  );
}

export default OldHeader